import React from 'react';
import { Box, IconButton } from '@mui/material';
import {
  ArrowUpward,
  ArrowDownward,
  ArrowBack,
  ArrowForward,
  Stop,
} from '@mui/icons-material';
import { PtzAction } from '../frigateApi';
import { useLanguage } from '../i18n/LanguageContext';

interface Props {
  onMove: (action: PtzAction) => void;
}

const PtzButton: React.FC<{
  action: PtzAction;
  label: string;
  onMove: (a: PtzAction) => void;
  children: React.ReactNode;
}> = ({ action, label, onMove, children }) => (
  <IconButton
    size="large"
    aria-label={label}
    onPointerDown={() => onMove(action)}
    onPointerUp={() => onMove('STOP')}
    onPointerLeave={() => onMove('STOP')}
    sx={{ touchAction: 'none' }}
  >
    {children}
  </IconButton>
);

export const PtzControls: React.FC<Props> = ({ onMove }) => {
  const { t } = useLanguage();
  return (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 56px)',
      gridTemplateRows: 'repeat(3, 56px)',
      gap: 0.5,
      mx: 'auto',
      width: 'fit-content',
    }}
  >
    <Box />
    <PtzButton action="UP" label={t.a11yPanUp} onMove={onMove}><ArrowUpward /></PtzButton>
    <Box />
    <PtzButton action="LEFT" label={t.a11yPanLeft} onMove={onMove}><ArrowBack /></PtzButton>
    <IconButton size="large" aria-label={t.a11yPanStop} onClick={() => onMove('STOP')}><Stop /></IconButton>
    <PtzButton action="RIGHT" label={t.a11yPanRight} onMove={onMove}><ArrowForward /></PtzButton>
    <Box />
    <PtzButton action="DOWN" label={t.a11yPanDown} onMove={onMove}><ArrowDownward /></PtzButton>
    <Box />
  </Box>
  );
};
